var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 35.7,
  fill: "none",
  width: 1.9,
  height: 0.9
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 33.1,
  y: 35.7,
  fill: "none",
  width: 1.9,
  height: 0.9
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M32.7,37.3h2.7c0.2,0,0.4-0.1,0.4-0.3v-1.3H37c0.2,0,0.3-0.2,0.3-0.4V8.1c0-0.2-0.1-0.4-0.3-0.4H8.1 c-0.2,0-0.4,0.2-0.4,0.4v27.2c0,0.2,0.2,0.4,0.4,0.4h1.1V37c0,0.2,0.2,0.3,0.4,0.3h2.7c0.2,0,0.4-0.1,0.4-0.3v-1.3h19.7V37 C32.4,37.2,32.5,37.3,32.7,37.3L32.7,37.3z M35,36.6h-1.9v-0.9H35V36.6z M11.9,36.6H10v-0.9h1.9L11.9,36.6z M8.4,34.9V8.4H17v26.5 H8.4z M17.7,34.9V8.4h9.6v26.5H17.7z M28,34.9V8.4h8.6v26.5H28z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M27.3,8.4h-9.6v26.5h9.6V8.4z M24.1,24.9V24c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v0.9 c0,0.2-0.2,0.4-0.4,0.4C24.3,25.3,24.1,25.1,24.1,24.9C24.1,24.9,24.1,24.9,24.1,24.9z M24.5,13h-4.1c-0.2,0-0.4-0.1-0.4-0.3 c0-0.2,0.2-0.4,0.4-0.4h4.1c0.2,0,0.4,0.2,0.4,0.4C24.9,12.9,24.7,13,24.5,13z M24.9,14.1c0,0.2-0.2,0.4-0.4,0.4h-4.1 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h4.1C24.7,13.7,24.9,13.9,24.9,14.1C24.9,14.1,24.9,14.1,24.9,14.1z M20.4,15.2h4.1 c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.3-0.4,0.3h-4.1c-0.2,0-0.4-0.1-0.4-0.3C20,15.4,20.2,15.2,20.4,15.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M17,8.4H8.4v26.5H17V8.4z M14.3,24c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.2,0.4,0.4v0.9c0,0.2-0.2,0.4-0.4,0.4 c-0.2,0-0.3-0.2-0.3-0.4V24z M15,12.7c0,0.2-0.2,0.3-0.4,0.3h-4c-0.3,0-0.4-0.1-0.4-0.3c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h4 C14.8,12.3,15,12.5,15,12.7L15,12.7z M10.6,13.7h4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-4c-0.2,0-0.4-0.2-0.4-0.4l0,0 C10.2,13.9,10.4,13.7,10.6,13.7C10.6,13.7,10.6,13.7,10.6,13.7z M10.6,15.2h4c0.2,0,0.4,0.2,0.4,0.4l0,0c0,0.2-0.2,0.3-0.4,0.3h-4 c-0.3,0-0.4-0.1-0.4-0.3C10.2,15.4,10.4,15.2,10.6,15.2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M36.6,8.4H28v26.5h8.6V8.4z M34,24.9V24c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.3,0.2,0.3,0.4v0.9 c0,0.2-0.1,0.4-0.3,0.4C34.2,25.3,34,25.1,34,24.9z M34.5,13h-4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.3,0.4-0.3h4 c0.2,0,0.4,0.1,0.4,0.3C34.9,12.8,34.7,13,34.5,13z M34.9,14.1c0,0.2-0.2,0.4-0.4,0.4h-4c-0.2,0-0.4-0.2-0.4-0.4 c0-0.2,0.2-0.4,0.4-0.4h4C34.7,13.7,34.9,13.9,34.9,14.1C34.9,14.1,34.9,14.1,34.9,14.1z M30.5,15.2h4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.3-0.4,0.3h-4c-0.2,0-0.4-0.1-0.4-0.3C30.1,15.4,30.3,15.2,30.5,15.2z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M24.5,12.3h-4.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.3,0.4,0.3h4.1c0.2,0,0.4-0.1,0.4-0.3 C24.9,12.5,24.7,12.3,24.5,12.3z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M24.5,13.7h-4.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h4.1c0.2,0,0.4-0.2,0.4-0.4 C24.9,13.9,24.7,13.7,24.5,13.7z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M20.4,15.9h4.1c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.4-0.4-0.4h-4.1c-0.2,0-0.4,0.2-0.4,0.4 C20,15.8,20.2,15.9,20.4,15.9z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M34.5,12.3h-4c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.4,0.4,0.4h4c0.2,0,0.4-0.2,0.4-0.4 C34.9,12.4,34.7,12.3,34.5,12.3z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M34.5,13.7h-4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h4c0.2,0,0.4-0.2,0.4-0.4 C34.9,13.9,34.7,13.7,34.5,13.7z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M30.5,15.9h4c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.4-0.4-0.4h-4c-0.2,0-0.4,0.2-0.4,0.4 C30.1,15.8,30.3,15.9,30.5,15.9z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M10.6,12.3c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.1,0.3,0.4,0.3h4c0.2,0,0.4-0.1,0.4-0.3 c0-0.2-0.2-0.4-0.4-0.4l0,0H10.6z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M10.6,14.5h4c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-4c-0.2,0-0.4,0.2-0.4,0.4l0,0 C10.2,14.3,10.4,14.5,10.6,14.5C10.6,14.5,10.6,14.5,10.6,14.5z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M10.6,15.9h4c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.4-0.4-0.4l0,0h-4c-0.2,0-0.4,0.2-0.4,0.4l0,0 C10.2,15.8,10.3,15.9,10.6,15.9z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M14.6,25.3c0.2,0,0.4-0.2,0.4-0.4V24c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.3,0.2-0.3,0.4v0.9 C14.3,25.1,14.4,25.3,14.6,25.3z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M24.9,24.9V24c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v0.9c0,0.2,0.2,0.4,0.4,0.4 C24.7,25.3,24.9,25.1,24.9,24.9C24.9,24.9,24.9,24.9,24.9,24.9z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M34.7,24.9V24c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.2-0.4,0.4v0.9c0,0.2,0.2,0.4,0.4,0.4 C34.6,25.3,34.7,25.1,34.7,24.9z"
});

function SvgPersonalStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalStorage);
export default __webpack_public_path__ + "static/media/personal_storage.8410356913bf6a2b9052bc2cd950af50.svg";
export { ForwardRef as ReactComponent };